var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',[_c('v-expansion-panel',{on:{"change":_vm.updatePanelState}},[_c('v-expansion-panel-header',{staticClass:"text-xs-h6 text-sm-h6"},[_vm._v(" Abbreviations Reference ")]),_c('v-expansion-panel-content',[_c('LabelAbbreviations',{attrs:{"h":"175"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }